export const REV_MGMT_CONTRACT_TYPES = {
  normal: { key: 'normal', label: 'Normal' },
  standalone: { key: 'standalone', label: 'Standalone' },
};

export const CONTRACT_NET_BASES = {
  net3: { key: 'net3', label: 'Net 3' },
  net2: { key: 'net2', label: 'Net 2' },
};

export const NEW_REV_MGMT_CONTRACT = {
  regions: [],
  year: new Date().getFullYear(),
  commissionRate: 0,
  marketingDeduction: 0,
  yearGoal: 0,
  fixedAmount: 0,
  warrantySum: 0,
  q1GoalPercent: 0,
  q2GoalPercent: 0,
  q3GoalPercent: 0,
  q4GoalPercent: 0,
  netBase: CONTRACT_NET_BASES.net3.key,
  contractType: REV_MGMT_CONTRACT_TYPES.normal.key,
};
